import { render, staticRenderFns } from "./figmaplugins.vue?vue&type=template&id=186ca576&scoped=true&"
import script from "./figmaplugins.vue?vue&type=script&lang=js&"
export * from "./figmaplugins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ca576",
  null
  
)

export default component.exports